import messages_en from "./en/messages_en.mjs";

export default {
  'en': {
    ...messages_en
  }
}
